import { EQpProfile } from '@library/models/qp-profile.models';
import { IAccount } from '@one/app/shared/models/account/account.models';
import { QimaOptionalType } from '@qima/ngx-qima';

export const BROWSER_SESSION_FINGERPRINT_STORAGE_KEY = 'qo-browser-session-fingerprint';

/**
 * Stable identity for cross-tab session coordination (email + sorted profiles).
 * @param account
 */
export function buildBrowserSessionFingerprint(account: QimaOptionalType<IAccount>): string {
  if (!account?.email) {
    return 'logged-out';
  }

  const profiles = [...(account.profiles ?? [])].sort((left: EQpProfile, right: EQpProfile): number => left.localeCompare(right));

  return `${account.email}|${profiles.join(',')}`;
}
